module.exports = __webpack_public_path__ + "img/car.46fba9ca.svg";